<div class="grid">
  <div class="col-12 md:col-8 md:col-offset-2">
    <div class="card px-6 py-6">
      <div class="flex justify-content-between align-items-center mb-4">
        <h5 class="m-0">My profile</h5>
        <a
          routerLink="/change-password"
          pButton
          pRipple
          icon="pi pi-key"
          label="Change password"
          class="p-button-outlined p-button-sm"
        ></a>
      </div>

      @if (loading()) {
        <div class="flex justify-content-center py-6">
          <p-progressSpinner styleClass="w-3rem h-3rem"></p-progressSpinner>
        </div>
      } @else {
        @if (profile(); as user) {
          <div class="grid">
            <div class="col-12 md:col-6 mb-3">
              <div class="text-500 text-sm">Name</div>
              <div class="text-900 font-medium">{{ user.firstName }} {{ user.lastName }}</div>
            </div>
            <div class="col-12 md:col-6 mb-3">
              <div class="text-500 text-sm">Email</div>
              <div class="text-900 font-medium">{{ user.email }}</div>
            </div>
            <div class="col-12 md:col-6 mb-3">
              <div class="text-500 text-sm">Phone</div>
              <div class="text-900 font-medium">{{ user.phoneNumber || 'N/A' }}</div>
            </div>
            <div class="col-12 md:col-6 mb-3">
              <div class="text-500 text-sm">Role</div>
              <div>
                <p-tag [value]="user.roleName | roleLabel" severity="info"></p-tag>
              </div>
            </div>
            <div class="col-12 md:col-6 mb-3">
              <div class="text-500 text-sm">Store</div>
              <div class="text-900 font-medium">{{ user.storeName || 'N/A' }}</div>
            </div>
            <div class="col-12 md:col-6 mb-3">
              <div class="text-500 text-sm">Member since</div>
              <div class="text-900 font-medium">{{ user.createdAt | date }}</div>
            </div>
          </div>
        } @else {
          <div class="text-center text-500 py-6">Could not load profile.</div>
        }
      }
    </div>
  </div>
</div>
